import React from 'react';
import { observer } from 'mobx-react';
import { useInjection } from 'inversify-react';
import type { interfaces } from 'inversify';
import styled from 'styled-components';
import { Banner } from '@/components/banner/Banner';
import { TYPES } from '@/engine/ioc';
import type { BannerController } from './Banner.controller';

export const Banners: React.FC = observer(() => {
  const bannerController = useInjection<BannerController>(
    TYPES.BannerController as interfaces.ServiceIdentifier<BannerController>
  );

  if (!bannerController.isVisible || !bannerController.bannerProps) {
    return null;
  }

  const { variant, content } = bannerController.bannerProps;

  return (
    <BannersContainer>
      <Banner variant={variant} content={content} onClose={() => bannerController.close()} />
    </BannersContainer>
  );
});

const BannersContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
`;
